import { Controller } from 'stimulus';
import Swiper, { A11y, EffectFade, Navigation, Pagination } from 'swiper';

Swiper.use([A11y, EffectFade, Navigation, Pagination]);

export default class extends Controller {
  static targets = ['slider', 'pagination', 'next', 'prev'];

  connect() {
    this.initSwiper();
  }

  disconnect() {
    this.destroySwiper();
  }

  initSwiper() {
    // Confirm that we want to initialize this instance as a slider
    const isSlider = this.sliderTarget.dataset?.isSlider === 'true';

    // Short-circuit if swiper is already initialized, or we don't want it to be
    if (this.swiper || !isSlider) return;

    const swiperOptions = {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    };

    if (this.paginationTarget) {
      swiperOptions.pagination = {
        el: this.paginationTarget,
        clickable: true,
      };
    }

    if (this.nextTarget && this.prevTarget) {
      swiperOptions.navigation = {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      }
    }

    // Initialize swiper
    this.swiper = new Swiper(this.sliderTarget, swiperOptions);
  }

  destroySwiper() {
    // Short-circuit if swiper is not initialized
    if (!this.swiper) return;

    // Destroy the swiper instance
    this.swiper.destroy(true, true);
  }
}
